let isuAssessmentComponent = {
bindings: {
    readonly: '<',
    required: '&',
    modelName: '@'
},
    templateUrl:`app/components/isu-assessment/isu-assessment.html`
};

export default isuAssessmentComponent;


// WEBPACK FOOTER //
// ./app/components/isu-assessment/isu-assessment.component.js